/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentAdditionalType
 */
export interface PaymentAdditionalType {
    /**
     * 
     * @type {string}
     * @memberof PaymentAdditionalType
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentAdditionalType
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentAdditionalType
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PaymentAdditionalType
     */
    documents: Array<string>;
}

export function PaymentAdditionalTypeFromJSON(json: any): PaymentAdditionalType {
    return PaymentAdditionalTypeFromJSONTyped(json, false);
}

export function PaymentAdditionalTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentAdditionalType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': json['type'],
        'description': json['description'],
        'documents': json['documents'],
    };
}

export function PaymentAdditionalTypeToJSON(value?: PaymentAdditionalType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'type': value.type,
        'description': value.description,
        'documents': value.documents,
    };
}


